export const gatherDeviceInfo = () => {
    const navigator = window?.navigator;
    const viewport = window?.visualViewport;

    return {
        userAgent: navigator?.userAgent,
        language: navigator?.language,
        viewport: {
            height: viewport?.height,
            width: viewport?.width,
        },
    };
};
